var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"project":_vm.project,"name":"Reports"}},[_c('requires-upgrade',{attrs:{"team_id":_vm.project.team_id}},[_c('p',[_vm._v("Project reports are only available on our paid plan.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }